import { render, staticRenderFns } from "./SingleRouteDetails.vue?vue&type=template&id=2ea9d99c"
import script from "./SingleRouteDetails.vue?vue&type=script&lang=js"
export * from "./SingleRouteDetails.vue?vue&type=script&lang=js"
import style0 from "./SingleRouteDetails.vue?vue&type=style&index=0&id=2ea9d99c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports